/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */
import { applyMiddleware, createStore, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

import { rootReducer } from "./reducers";
import { testSaga } from "./sagas";
import authSaga from "./sagas/auth.saga";
import meSaga from "./sagas/me.saga";
import { RootState } from "../types/RootState";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { Persistor, persistStore } from "redux-persist";

const sagaMiddleware = createSagaMiddleware();

export function buildStore(history): Store<RootState> {
    const store = createStore<RootState>(
        connectRouter(history)(rootReducer),
        composeWithDevTools(applyMiddleware(sagaMiddleware, routerMiddleware(history)))
    );
    return store;
}

export function buildPersistor(store: Store<RootState>): Persistor {
    // Run sagas after rehydrating.
    return persistStore(store, {}, () => {
        sagaMiddleware.run(testSaga);
        sagaMiddleware.run(authSaga);
        sagaMiddleware.run(meSaga);
    });
}

export type GetState = () => RootState;



// WEBPACK FOOTER //
// ./src/store/index.ts